function Ctrl($scope, utilsService, conciergeService, modalService) {
  $scope.message = $scope.message || '';

  $scope.isMobile = utilsService.isMobileDevice();

  $scope.chat = function() {
    modalService.authUser(() => {
      conciergeService.sendMessage($scope.message, true);
    }, null, {
      startState: 'existingUser'
    });
  };

  $scope.email = function() {
    utilsService.mailto('hello@tablelist.com', 'Question for Tablelist Concierge', $scope.message);
  };

  $scope.sms = function() {
    utilsService.sms(6173408791, $scope.message);
  };
}

Ctrl.$inject = [
  '$scope',
  'utilsService',
  'conciergeService',
  'modalService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/directives/contactOptions/controller.js